// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './styles/index.scss' // global css
import '@/permission' // permission control
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import store from './store'
import 'lodash'
import '@/icons' // icon


Vue.config.productionTip = false
Vue.use(ElementUI, { locale, size: 'small' })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js